<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Report Configurations</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body ttmodal__sp">
    <div class="spinner" *ngIf="loading">
      <mat-spinner> </mat-spinner>
    </div>
    <div class="maindiv">
      <div *ngFor="let item of ReportConfigList" style="background-color: white; padding-bottom: 10px;">
        <div class="dropzone"
             draggable="true"
             (dragstart)="drag($event)"
             (drop)="drop($event)"
             (dragover)="allowDrop($event)"
             attr.id="{{item.Id}}">
          <div style="display: flex; flex-direction: row; align-items: center; justify-content:space-between;">
            <div class="comparttype">{{item.CompartType}}</div>
            <!-- <div style="display:none; display: flex; flex-direction: column;">
    <mat-checkbox style="padding-right: 8px;" [disabled]="true" [checked]="item.IncludeMeasurementImage" (change)="toggleIncludes(item.Id, item.CompartTypeId, item.MiningShovelReportId, 'IncludeMeasurementImage', item.SortOrder, $event)">
      <span class="label-reportoption">Measurement Image</span>
    </mat-checkbox>
    <mat-checkbox style="padding-right: 8px;" [disabled]="true" [checked]="item.IncludeObservationsTable" (change)="toggleIncludes(item.Id, item.CompartTypeId, item.MiningShovelReportId, 'IncludeObservationsTable', item.SortOrder, $event)">
      <span class="label-reportoption">Observations Table</span>
    </mat-checkbox>
    <mat-checkbox style="padding-right: 8px;" [disabled]="true" [checked]="item.IncludeGraph" (change)="toggleIncludes(item.Id, item.CompartTypeId, item.MiningShovelReportId, 'IncludeGraph', item.SortOrder, $event)">
      <span class="label-reportoption">Graph</span>
    </mat-checkbox>
    <mat-checkbox style="padding-right: 8px;" [disabled]="true" [checked]="item.IncludeImages" (change)="toggleIncludes(item.Id, item.CompartTypeId, item.MiningShovelReportId, 'IncludeImages', item.SortOrder, $event)">
      <span class="label-reportoption">Images</span>
    </mat-checkbox>
    <mat-checkbox style="padding-right: 8px;" [disabled]="true" [checked]="item.IncludeComments" (change)="toggleIncludes(item.Id, item.CompartTypeId, item.MiningShovelReportId, 'IncludeComments', item.SortOrder, $event)">
      <span class="label-reportoption">Comments/Notes Box</span>
    </mat-checkbox>
  </div> -->
            <div class="arrows">
              <span title="Move up"
                    [class.button-hide]="item.SortOrder==1?true:false"
                    (click)="recalculateSortOrder(item.Id, item.MiningShovelReportId, item.SortOrder, -1)">
                <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
              </span>
              <span title="Move down"
                    [class.button-hide]="item.SortOrder>ReportConfigList.length-1?true:false"
                    (click)="recalculateSortOrder(item.Id, item.MiningShovelReportId, item.SortOrder, 1)">
                <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ttmodal__footer divrightcontent">
    <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Close</span></a>
  </div>
</div>


